import { Component, Input } from '@angular/core';
import { Entry } from 'contentful';

@Component({
  selector: 'nibtravel-snippet',
  template: `
    <nibtravel-embedded-entry
      [type]="entry?.sys?.contentType?.sys?.id"
      [fields]="entry?.fields"
      [props]="props"
    ></nibtravel-embedded-entry>
  `,
})
export class SnippetComponent<T> {
  @Input() entry!: Entry<T>;
  @Input() props!: Record<string, any>;
}
